import { Outlet, useLocation } from 'react-router-dom';
import { Header, SidebarMenu } from '@components';
import './ProductLayout.scss';
import { useFilteredProductsMenuItems } from '../../utils/menu';
import { useEffect } from 'react';
import { useRef } from 'react';
import { useAuthentifiedLayout } from '@layout/AuthentifiedLayout/useAuthentifiedLayout';

export const ProductLayout = () => {
    useAuthentifiedLayout();

    const layoutRef = useRef<HTMLDivElement>(null);
    const { pathname, hash } = useLocation();
    const filteredProductsMenuItems = useFilteredProductsMenuItems();

    useEffect(() => {
        if (hash) {
            const element = document.getElementById(hash.slice(1));
            if (element) {
                layoutRef.current?.scrollTo(0, element.offsetTop);
            }
        } else {
            layoutRef.current?.scrollTo(0, 0);
        }
    }, [pathname, hash]);

    return (
        <div className="product-layout layout" data-theme="products">
            <Header />
            <div ref={layoutRef} className="rendered-page">
                <SidebarMenu items={filteredProductsMenuItems} activeParentItem={'product'} />
                <Outlet />
            </div>
        </div>
    );
};

export default ProductLayout;
